import { useQuery } from "@apollo/client/react";
import { OrganizationalRecordAccessDocument } from "@/graphql/generated/operations";

export type OrganizationalRecordAccess = { canRead: boolean; canWrite: boolean };

export function useOrganizationalRecordAccess(): OrganizationalRecordAccess {
  // The profile entry point and panel share this fresh check, including after role revocation.
  const { data, error } = useQuery(OrganizationalRecordAccessDocument, {
    fetchPolicy: "no-cache",
    pollInterval: 60_000,
    notifyOnNetworkStatusChange: false,
  });
  const canRead = !error && data?.organizationalRecordAccess.canRead === true;
  return { canRead, canWrite: canRead && data?.organizationalRecordAccess.canWrite === true };
}
